import {
  SET_LOADING,
  SAVE_DATA,
  SET_ACTIVE_PAGE,
  SAVE_BULK_USERS,
} from './constants';

export function setLoading(isLoading) {
  return {
    type: SET_LOADING,
    isLoading,
  };
}

export function saveData(data) {
  return {
    type: SAVE_DATA,
    data,
  };
}

export function setActivePage(pageNumber) {
  return {
    type: SET_ACTIVE_PAGE,
    pageNumber,
  };
}

export function saveBulkUsers(data) {
  return {
    type: SAVE_BULK_USERS,
    data,
  };
}



// WEBPACK FOOTER //
// ./src/Modules/MyOrganization/actions.js